// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"4d21f8a6","683":"4187128b"}[chunkId] + ".chunk.css";
};